import { useEffect, useState } from 'react';

/**
 * Debounce a fast-changing value (e.g. a search input) so consumers
 * (network queries, filter computations) don't fire on every keystroke.
 *
 * Returns the latest value of `value` after `delayMs` of quiescence.
 * Falls back to the current value immediately on mount.
 */
export function useDebouncedValue<T>(value: T, delayMs = 250): T {
  const [debounced, setDebounced] = useState<T>(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
}
